import BooleanView from "components/common/views/BooleanView";
import { SortEnumType } from "types/graphql";
import { DateFormats, DateUtil } from "utilities/date-utilities";

export function resolveSort<TSortType>(name: string, direction: SortEnumType) {
    let obj: any = {};
    obj[name] = direction;

    return obj as TSortType;
}


export function resolveItemViewValue(propertyName: string, item: any, type?: string) {
    switch (type) {
        case 'date':
        case 'dateOnly':
            return DateUtil.format(new Date(item[propertyName]), DateFormats.SHORT);
        case 'boolean':
            return <BooleanView value={item[propertyName]} />;
        default:
            return item[propertyName]?.toString() || '-';
    }
}

export function formatMoney(numberValue?: number | string, fixed?: number) {
    let number = Number(numberValue);
    fixed = fixed ?? 2;
    if(number === undefined || number === null || isNaN(number)) return numberValue;
    let formattedNumber = number.toFixed(fixed);
    if(number < 0) formattedNumber = formattedNumber.substring(1, formattedNumber.length)
    const pinterIndex = fixed ? formattedNumber.indexOf('.') : formattedNumber.length;
    let val = fixed > 0 ? formattedNumber.substring(pinterIndex) : '';
    for (let index = 0; index < (pinterIndex); index++) {
        if(index % 3 === 0 && index > 0) val = "," + val;
        val = formattedNumber[(pinterIndex - 1 - index)] + val;
    }

    return (number < 0 ? '-' : '') + val;
}
